import React, { createContext, useContext, useState } from 'react';
import * as api from '../api/purchaseApi';
import { PurchaseInvoice } from '../types/purchase';

interface PurchaseContextProps {
    purchases: PurchaseInvoice[];
    fetchPurchases: () => Promise<void>;
    addPurchase: (purchase: Omit<PurchaseInvoice, 'id'>) => Promise<PurchaseInvoice>;
    updatePurchase: (purchase: PurchaseInvoice) => Promise<void>;
    deletePurchase: (id: string) => Promise<void>;
}

const PurchaseContext = createContext<PurchaseContextProps>({} as any);

export const PurchaseProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [purchases, setPurchases] = useState<PurchaseInvoice[]>([]);

    const fetchPurchases = async () => setPurchases(await api.getPurchases());
    const addPurchase = async (purchase: Omit<PurchaseInvoice, 'id'>) => {
        const newPurchase = await api.createPurchase(purchase);
        setPurchases(s => [newPurchase, ...s]);
        return newPurchase;
    };
    const updatePurchase = async (purchase: PurchaseInvoice) => {
        const updated = await api.updatePurchaseApi(purchase.id!, purchase);
        setPurchases(s => s.map(x => x.id === purchase.id ? updated : x));
    };
    const deletePurchase = async (id: string) => {
        await api.deletePurchaseApi(id);
        setPurchases(s => s.filter(x => x.id !== id));
    };

    return (
        <PurchaseContext.Provider value={{ purchases, fetchPurchases, addPurchase, updatePurchase, deletePurchase }}>
            {children}
        </PurchaseContext.Provider>
    );
};

export const usePurchase = () => useContext(PurchaseContext);
